module.exports = __webpack_public_path__ + "img/jiantouRight2.6825cd5e.svg";